import { Grid } from "@material-ui/core";
import { UserField, UserInputTypeKey } from "common/components/input/fields";
import { SubformProps } from "common/components/SubformProps";
import { UpdateUserManageable } from "common/store/user/types";
import React from "react";

export const UserEmploymentSubform = (props: SubformProps<UpdateUserManageable>) =>
  <Grid container direction="column" spacing={5}>
    <Grid item xs={12} lg={12} md={12}>
      <UserField id={"employment" as UserInputTypeKey} {...props} />
    </Grid>

    <Grid item xs={12} lg={12} md={12}>
      <UserField
        id={"highestEducation" as UserInputTypeKey}
        className="autocomplete"
        {...props}
      />
    </Grid>
  </Grid>
;
